import { AfterViewInit, Component, DoCheck, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { Subscription } from 'rxjs';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';

@Component({
    selector: 'formly-calendar-input',
    templateUrl: "./formly-calendar-input.component.html",
    standalone: false
})
export class FormlyCalendarInputComponent extends FieldType implements OnInit, OnDestroy, AfterViewInit, DoCheck {
  @Output() dateChange = new EventEmitter<Date>();
 
  @ViewChild("dateInput") dateInput: any;
  isFormSubmitted: boolean = false;
  formSubmissionSubscription: Subscription;
  isLabelVisible: boolean = false;
  addTopMargin: boolean = false;
  calendarLabel: string = "";
  dateFormats = [
    {
     id:1,
     name:"d/m/y"
    },
    { 
      id:2,
      name:"d/m/Y"
    },
    {
      id:3,
      name:"m/d/d"
    },
    {
      id:4,
      name:"m/d/Y"
    },
    {
      id:5,
      name:"y/m/d"
    },
    {
      id:6,
      name:"Y/M"
    },
    {
      id:7,
      name:"m-d-y"
    },
    {
      id:8,
      name:"d-m-y"
    },
    {
      id:9,
      name:"d-M-y"
    },
    {
      id:10,
      name:"d-M-Y"
    },
    {
      id:11,
      name:"d.m.y"
    },
    {
      id:12,
      name:"d.m.Y"
    },
    {
      id:13,
      name:"y.m.d"
    },
    {
      id:14,
      name:"M d, y"
    },
    {
      id:15,
      name:"M d, Y"
    },
    {
      id:16,
      name:"dmy"
    },
    {
      id:17,
      name:"ymd"
    },
    {
      id:18,
      name:"dmY"
    },
    {
      id:19,
      name:"Ymd"
    },
  ];
  dateFormatString: string = "d-M-Y";
  datePickerOptions: FlatpickrOptions = {
    mode: "single",
    defaultDate: new Date(),
    altInput: true,
    altFormat: this.dateFormatString,
    dateFormat: this.dateFormatString
  };
  disabled:boolean;
  private flatpickrInstance: any;
  private lastAppliedMinDate: number | null = null;
  private lastAppliedMaxDate: number | null = null;
  constructor(private dynamicFormService: DynamicFormService) {
    super();
  }
 

  ngOnInit() {
    this.datePickerOptions.defaultDate = new Date();
    if (this.field && this.field.formControl && this.field.formControl.value) {
      this.datePickerOptions.defaultDate = new Date(this.field.formControl.value);
    }

    if (this.field && this.field.props) {
      this.calendarLabel = this.field.props.label ? this.field.props.label :'';
      this.isLabelVisible = this.field.props.isLabelVisible;
      this.addTopMargin = this.field.props.addTopMargin;
      if(this.field.props.hideDefaultDate)
      {
        this.datePickerOptions.defaultDate = this.field.props.hideDefaultDate ? '' : this.datePickerOptions.defaultDate;
      }
    }

    if (this.field && this.field.props && this.field.props.maxDate) {
      this.datePickerOptions.maxDate = new Date(this.field.props.maxDate);
    }

    if (this.field && this.field.props && this.field.props.minDate) {
      this.datePickerOptions.minDate = new Date(this.field.props.minDate);
    }

    if (this.field && this.field.props && this.field.props.dateFormat) {
      this.datePickerOptions.dateFormat = this.field.props.dateFormat;
      this.dateFormatString = this.dateFormats.find(it=>it.id==this.field.props.dateFormat).name;
      this.datePickerOptions = {
        mode: "single",
        defaultDate: new Date(),
        altInput: true,
        altFormat: this.dateFormatString,
        dateFormat: this.dateFormatString
      };
    }

    if (this.field && this.field.props && this.field.props.altFormat) {
      this.datePickerOptions.altFormat = this.field.props.altFormat;
    }

    

    this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
      this.isFormSubmitted = data;
    });
  }

  ngOnDestroy() {
    if (this.formSubmissionSubscription) {
      this.formSubmissionSubscription.unsubscribe();
    }
  }

  ngAfterViewInit() {
    //Initialize datePicker
    this.flatpickrInstance = this.dateInput.nativeElement.flatpickr(this.datePickerOptions);
    if (this.field?.props?.minDate) {
      this.lastAppliedMinDate = new Date(this.field.props.minDate).getTime();
    }
    if (this.field?.props?.maxDate) {
      this.lastAppliedMaxDate = new Date(this.field.props.maxDate).getTime();
    }
  }

  ngDoCheck() {
    if (!this.flatpickrInstance || !this.field?.props) {
      return;
    }
    const minProp = this.field.props.minDate;
    if (minProp) {
      const minTime = new Date(minProp).getTime();
      if (!isNaN(minTime) && minTime !== this.lastAppliedMinDate) {
        this.lastAppliedMinDate = minTime;
        this.flatpickrInstance.set('minDate', new Date(minTime));
      }
    }
    const maxProp = this.field.props.maxDate;
    if (maxProp) {
      const maxTime = new Date(maxProp).getTime();
      if (!isNaN(maxTime) && maxTime !== this.lastAppliedMaxDate) {
        this.lastAppliedMaxDate = maxTime;
        this.flatpickrInstance.set('maxDate', new Date(maxTime));
      }
    }
  }

  onValueChange() {
    if (this.to.change) {
      this.to.change(this.field, this.formControl.value);
    }
  }
}
